import { type TaskTemplateTypeEnum } from '@app/data/tasks/constants';

/**
 * @deprecated This object is deprecated and will be removed in future.
 * Use from crm-atoms package instead
 */
export const listTaskTemplates = `
query {
  taskTemplates {
    id
    name
    taskType
    isDefault
    defaultDueTime
  }
}
`;

/**
 * @deprecated This object is deprecated and will be removed in future.
 * Use from crm-atoms package instead
 */
export interface TaskTemplateType {
  id: string;
  name: string;
  taskType: TaskTemplateTypeEnum;
  isDefault: boolean;
  defaultDueTime: number;
}

/**
 * @deprecated This object is deprecated and will be removed in future.
 * Use from crm-atoms package instead
 */
export interface TaskTemplateListType {
  taskTemplates: TaskTemplateType[];
}
